import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as _modalIcon } from 'Images/new_vuln_modal_icon.svg';
import { ReactComponent as NextSVG } from 'Images/next_arrow.svg';
import { ReactComponent as VulvSVG } from 'Images/ico-vulnerability-templates.svg';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';
import { FORM_ACTION_MIN_WIDTH } from 'shared/ui/Button/Button.constants';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  user-select: none;
  margin-bottom: 15px;
`;

export const Title = styled.div`
  width: 350px;
  height: 32px;
  font-size: 21.5px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.49;
  letter-spacing: normal;
  color: ${colors.blue9};
`;
Title.displayName = 'Title';

export const ModalIcon = styled(_modalIcon)`
  cursor: default;
  & path{
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
  }
`;

export const NextIcon = styled(NextSVG)`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  margin-left: 10px;
`;
NextIcon.displayName = 'NextIcon';

export const VulvIcon = styled(VulvSVG)`
  width: 20px;
  height: 20px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  border: 1px solid black;
  /* margin-left: 10px; */
`;
VulvIcon.displayName = 'VulvIcon';

export const ButtonWrapper = styled.div``;

export const CancelButton = styled(BaseCancelButton)`
  min-width: ${FORM_ACTION_MIN_WIDTH};
  margin-right: 10px;
`;
CancelButton.displayName = 'CancelButton';

export const CreateButton = styled(Button)`
  min-width: ${FORM_ACTION_MIN_WIDTH};
  margin-left: 10px;
  margin-right: 10px;
  user-select: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  background-color: ${({ disabled }) => (disabled ? colors.blue12 : colors.blueCerulean)};
  opacity:1;

  & svg {
    margin-bottom: 2px;
  }
`;
CreateButton.displayName = 'CreateButton';
